import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'shared/environments/environment';

export interface VoicePreset {
  id: string;
  title: string;
  subtitle?: string;
  imageUrl: string;
  languages: string[];
}

export interface VoicePresetsResponse {
  presets: VoicePreset[];
  // The effective pick for this item after server-side eligibility resolution.
  selectedPresetId: string;
}

// Presets are per item (they depend on the item's language), fetched lazily when the
// voice picker opens — the same trigger iOS uses.
@Injectable({ providedIn: 'root' })
export class VoicePresetsService {
  private readonly http = inject(HttpClient);

  getPresets(itemId: string): Observable<VoicePresetsResponse> {
    return this.http.get<VoicePresetsResponse>(`${environment.serviceUrl}/voice-presets`, {
      params: new HttpParams().set('itemId', itemId),
      withCredentials: true,
    });
  }
}
